export default {
  path: '/company-article',
  title: '公司发文',
  title_EN: 'Company Article',
  icon: 'mdi-format-float-right',
  access: '公司发文',

  children: [
    {
      title: '公司发文',
      icon: 'mdi-equalizer',
      group: '/base',
      children: [
        {
          path: '/article',
          name: 'company-article',
          component: () =>
            import('@/views/company-article/article/company-article.vue'),
          meta: {
            title: '公司发文',
            access: '公司发文:列表',
          },
        },
        {
          path: '/article-detail/:id',
          name: 'company-article-detail',
          component: () =>
            import(
              '@/views/company-article/article/company-article-detail.vue'
            ),
          meta: {
            title: '公司发文详情',
            access: '公司发文:列表',
            notShowInNav: true,
          },
        },
      ],
    },
  ],
}
